/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_2_DescInputs */

const et_case_2_desc = /** @type {(inputs: Case_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kasvatame House of Om’i orgaanilist liiklust 6 kuuga 10 korda, jõudes 10 200 igakuise külastajani. Ehitasime nähtavuse üle 420 märksõna ja tugeva autoriteedi 3700 tagasilingi kaudu 643 domeenilt. Sisu on nüüd viidatud üle 1150 korra AI platvormidel (ChatGPT, Google AI, Gemini), kasvatades pikaajalist liiklust veelgi.`)
};

const en_case_2_desc = /** @type {(inputs: Case_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scaled House of Om’s organic traffic 10x in 6 months, reaching 10,200 monthly visitors. Built visibility across 420+ keywords with strong authority from 3,700 backlinks across 643 domains. Content is now referenced 1,150+ times by AI platforms (ChatGPT, Google AI, Gemini), compounding long-term traffic growth.`)
};

/**
* | output |
* | --- |
* | "Scaled House of Om’s organic traffic 10x in 6 months, reaching 10,200 monthly visitors. Built visibility across 420+ keywords with strong authority from 3,70..." |
*
* @param {Case_2_DescInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const case_2_desc = /** @type {((inputs?: Case_2_DescInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_2_DescInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_case_2_desc(inputs)
	return en_case_2_desc(inputs)
});